export default "__VITE_ASSET__CQZs8zGm__"